<template>
  <el-dialog :visible.sync="dialogTableVisible" :modalAppendToBody="false" v-loading.fullscreen.lock="fullScreenLoading" v-if="artistInfo" @closed="closeDialog">
    <div v-if="artistInfo" id="dialog-area" class="artist_info">
      <h3 class="artist_name" v-html="artistInfo.name"></h3>
      <div class="artist_image">
        <img :src="artistInfo.photo_url" class="image" style="max-width:100%;">
      </div>
      <div class="site_links" v-if="artistInfo.site_links">
        <ul>
          <li class="site_official" v-if="artistInfo.site_links.official">
            <a :href="artistInfo.site_links.official">
              <img src="../../assets/images/official_btn.png" class="image" />
            </a>
          </li>
          <li class="site_label" v-if="artistInfo.site_links.label">
            <a :href="artistInfo.site_links.label" style="">
              <img src="../../assets/images/label_btn.png" class="image"/>
            </a>
          </li>
          <li class="site_facebook" v-if="artistInfo.site_links.facebook">
            <a :href="artistInfo.site_links.facebook" >
              <i style="color: #3b5998;" class="fab fa-facebook-f"></i>
            </a>
          </li>
          <li class="site_twitter" v-if="artistInfo.site_links.twitter">
            <a :href="artistInfo.site_links.twitter">
              <i class="fab fa-twitter" style="color: #2fa8e1"></i>
            </a>
          </li>
          <li class="site_instagram" v-if="artistInfo.site_links.instagram">
            <a :href="artistInfo.site_links.instagram">
              <i class="fab fa-instagram" style="color: #69443b"></i>
            </a>
          </li>
          <li class="site_youtube" v-if="artistInfo.site_links.youtube">
            <a :href="artistInfo.site_links.youtube">
              <i class="fab fa-youtube-square" style="color:#e62918;"></i>
            </a>
          </li>
          <li class="site_soundcloud" v-if="artistInfo.site_links.soundcloud">
            <a :href="artistInfo.site_links.soundcloud">
              <i class="fab fa-soundcloud" style="color: #ee761c"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="info-body">
        <div class="music_area" v-if="artistInfo.music_box_url" style="margin-bottom: 20px">
          <iframe :src="artistInfo.music_box_url" width="300" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
        </div>
        <div class="description_area" v-if="artistInfo.description" style="margin-bottom: 20px">
          <p class="artist_description" v-html="artistInfo.description"></p>
        </div>
      </div>
      <div id="modalBtnBox">
        <ul class="modalBtn">
          <li class="modalBtnClose" @click="dialogTableVisible = false">× CLOSE</li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
const ENDPOINT = process.env.API_ENDPOINT
export default {
  name: 'ArtistDialog',
  props: {
    dialogTableVisible: true,
    artistId: null
  },
  data () {
    return {
      artistInfo: '',
      fullScreenLoading: false,
      headerSize: 0
    }
  },
  watch: {
    dialogTableVisible: function (val) {
      this.dialogTableVisible = val
      if (this.dialogTableVisible === true) {
        this.getArtistInformation()
      } else {
        // 親のdialogTableVisibleもダイアログclose時に更新する
        this.$parent.dialogTableVisible = false
      }
    },
    artistId: function (val) {
      this.artistId = val
    }
  },
  methods: {
    getArtistInformation () {
      this.$parent.$parent.loading = true
      this.artistInfo = null
      // アーティストIDがなかった場合何もしない
      if (!this.artistId) {
        this.$notify.info({
          message: '当日をお楽しみください！'})
        this.$parent.dialogTableVisible = false
        this.$parent.$parent.loading = false
        this.$parent.stagePreviews()
        return
      }
      this.dialogTableVisible = true
      this.fullScreenLoading = true
      axios.post(ENDPOINT + '/artistInformation', { artist_id: this.artistId }).then((response) => {
        this.fullScreenLoading = false
        this.artistInfo = response.data
        this.dialogTableVisible = true
        this.$parent.$parent.position = 'fixed'
        this.$parent.$parent.scrollY = ((window.scrollY - this.headerSize) * -1)
        this.$parent.$parent.loading = false
        this.$parent.stagePreviews()
      }).catch((e) => {
        this.dialogTableVisible = false
        this.fullScreenLoading = false
        this.$parent.$parent.loading = false
        this.$parent.stagePreviews()
      })
    },
    closeDialog: function () {
      this.$parent.$parent.position = ''
      // 画面をスクロールするための座標計算
      let element = document.getElementById('table_area')
      let style = (element.currentStyle || document.defaultView.getComputedStyle(element, '')).top
      style = style.replace('-', '')
      style = parseInt(style.replace('px', ''))
      style += this.headerSize
      this.$parent.$parent.handleScroll(style)
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/css/components/parts/ArtistDialog";
</style>



// WEBPACK FOOTER //
// src/components/parts/ArtistDialog.vue